import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import VueStore from "@/store/VueStore";
import router from "@/router";
import {
  MstSeatMappingType,
  SeatSensorStateType,
  AuthStoreType,
  SeatSensorData,
} from "@/types/types";
import { RequestParamsMaker } from "@/components/seatMapping/scripts/make_request_params";
import mstSeatMappingService from "@/services/mst_seat_mapping_service";
import CognitoController from "@/common/scripts/cognito_controller";
import SignalContent from "../signalContent/signal_content";
import { getLatestData } from "@/components/seatMapping/scripts/get_latest_sensor_data";
import { makeListDataSets, chartHistoryGraph } from "@/components/seatMapping/scripts/chart_history_graph";

@Component({})
export default class SeatMappingComponent extends Vue {
  @Prop() public mstSeatMapping: MstSeatMappingType;
  @Prop() public editFlag: boolean;
  @Prop() public authStore: AuthStoreType;

  public userID: string = JSON.parse(localStorage.getItem("iotKyotoAuth")).userName;
  // 最新の在席データ
  public latestSensorData: SeatSensorData = null;
  public latestDataDate: string = "未取得";
  public timeZone: string =
    typeof JSON.parse(localStorage.getItem("graphSettings")).useTimeZone ===
      "undefined"
      ? "+09:00"
      : JSON.parse(localStorage.getItem("graphSettings")).useTimeZone;
  public reloadEvent: any = null;
  public signallampID: number = null;
  public mstSignallampSetting: any = null;

  public noneFlash: boolean = false;
  public errorMassage: string = "";
  // 初回データ取得が失敗したかどうか
  public isError: boolean = false;

  // 在席しているかどうか
  public isExist: boolean = false;

  // 過去状況
  public getHistoryData: any = [];

  public async mounted() {
    try {
      if (VueStore.state.token === null) {
        return router.push("/signIn");
      }

      // センサーデータの取得 座席のカラーを設定
      await this.getAndApplyLatestSensorData();

      // 初回表示に問題がなければ5秒インターバルでデータ取得&表示処理を行う
      if (this.reloadEvent === null && !this.isError) {
        this.reloadEvent = setInterval(() => {
          this.getAndApplyLatestSensorData();
        }, 1000);
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * ドラッグ終了時の位置を保存
   * @param x
   * @param y
   */
  public async onDragStop(x: number, y: number) {
    (this.mstSeatMapping.sensor_state as SeatSensorStateType).xPosition = x;
    (this.mstSeatMapping.sensor_state as SeatSensorStateType).yPosition = y;
    await mstSeatMappingService.update(this.mstSeatMapping);
  }

  /**
   * リサイズ操作終了時の設定を保存
   * @param x
   * @param y
   * @param w
   * @param h
   */
  public async onResizeStop(x: number, y: number, w: number, h: number) {
    (this.mstSeatMapping.sensor_state as SeatSensorStateType).xPosition = x;
    (this.mstSeatMapping.sensor_state as SeatSensorStateType).yPosition = y;
    (this.mstSeatMapping.sensor_state as SeatSensorStateType).width = w;
    (this.mstSeatMapping.sensor_state as SeatSensorStateType).height = h;
    await mstSeatMappingService.update(this.mstSeatMapping);
  }

  /**
   * 最新の在席センサーデータを取得し、表示内容を変更する
   */
  private async getAndApplyLatestSensorData() {
    const latestSeatSensorData = await getLatestData(this);

    if (!latestSeatSensorData) {
      return;
    }

    this.applySeatColor(latestSeatSensorData);
  }

  /**
   * CSS用に1,0からbooleanに変換
   * @param latestSeatSensorData SeatSensorData
   */
  private applySeatColor(latestSeatSensorData: SeatSensorData) {
    if (latestSeatSensorData.pir_status === 1) {
      this.isExist = true;
      return;
    }
    this.isExist = false;
  }

  /**
   * 選択している在席センサーの情報を設定
   */
  public setSelectMstSeatMapping() {
    const parent: any = this.$parent;
    parent.selectmstSeatMapping = this.mstSeatMapping;
    parent.deviceId = this.mstSeatMapping.device_id;
    parent.displayName = (this.mstSeatMapping.sensor_state as SeatSensorStateType).displayName;
  }

  public displayGraph() {
    const parent: any = this.$parent;
    if (parent.editSensorAreaFlag) {
      return;
    }
    this.setSelectMstSeatMapping();

    parent.historyArea = true;
    parent.seatAreaOverlay = true;
    parent.toTime = moment().format("YYYY-MM-DD HH:mm");
    parent.fromTime = moment()
      .subtract(8, "hours")
      .format("YYYY-MM-DD HH:mm");

    // 過去データ取得
    // this.inquiryHistory();
  }

  /**
   * 過去状況ボタン クリック処理。
   * @returns {Promise<void>}
   */
  public async inquiryHistory() {
    const indexComponent = this.$parent.$parent.$parent;
    indexComponent.$data.historyDatasets = [];

    console.log("indexComponent", indexComponent);

    const req: object = RequestParamsMaker.makeGetSeatHistory(
      this.userID,
      this.authStore,
      this.mstSeatMapping.device_id,
    );
    const getHistoryDataResult = await axios(req);
    const historyData = getHistoryDataResult.data.res.seat_sensor_data;
    console.log("historyData", historyData);
    const toTime = moment().utc().format("YYYY-MM-DD HH:mm:ssZ");
    const fromTime = moment()
      .utc()
      .subtract(8, "hours")
      .format("YYYY-MM-DD HH:mm:ssZ");

    indexComponent.$data.historyDatasets = makeListDataSets(
      historyData,
      this
    );
    // indexComponent.$data.ToTime = "現在時刻";
    // indexComponent.$data.FromTime = "8時間前";
    // indexComponent.$data.chart = chartHistoryGraph(
    //   this.getHistoryData,
    //   toTime,
    //   fromTime,
    // );
  }
}
